import * as React from 'react';
import { Button, Form, Header, Image, GridRow, Segment, Grid } from 'semantic-ui-react';

import configs from '../helpers/config';
import LinkButton from './LinkButton';

class LoginMedico extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...configs.DEFAULT_MEDICO };
        this.inputs = [];
    }

    handleLogin() {
        const { codigo, senha } = this.state;

        if (codigo && senha) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: 'PortalResultadosLoginMedico' }).then(token => {
                    this.setState({ recaptcha_token: token });
                    this.props.onClick({ ...this.state });
                    this.setState({ ...configs.DEFAULT_MEDICO });
                });
            });
        } else {
            alert('Insira a os dados de acesso corretamente');
        }
    }

    render() {
        return (
            <Segment className={this.props.className}>

                <Header as='h2'>
                    <p className='headerLogin'><Image src={require('../img/medico2.png')} className='imgLogoLoginMedico' size='mini' avatar />MÉDICO</p>
                </Header>

                <Form size='large'>
                    <GridRow >
                        <p>Acesse aqui os laudos de seus pacientes</p>
                        <Form.Input
                            fluid
                            icon='at'
                            iconPosition='left'
                            placeholder='Email'
                            value={this.state.codigo}
                            onChange={(e) => this.setState({ ...this.state, codigo: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon='lock'
                            iconPosition='left'
                            placeholder='Senha'
                            value={this.state.senha}
                            type='password'
                            onChange={(e) => this.setState({ ...this.state, senha: e.target.value })}
                        />

                        <Button fluid size='large' onClick={() => this.handleLogin()}>
                            ENTRAR
                        </Button >
                        <br />
                        <Grid columns={2} >
                            <Grid.Row >
                                <Grid.Column >
                                    <LinkButton onClick={this.props.recuperar} >Esqueci minha senha</LinkButton>
                                </Grid.Column>
                                <Grid.Column >
                                    <LinkButton onClick={this.props.medicosregistro} >Não tenho cadastro</LinkButton>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </GridRow>
                </Form>

            </Segment >);
    }
}

export default LoginMedico;
